import { prependOnceListener } from "process"

interface PopUpProps {
    title: string;
    element: JSX.Element;
    onClick: () => void;
}
  
export function PopUp(props: PopUpProps) {
    return (
        <div className="popup-overlay">
            <div className="popup">
                <h2>{props.title}</h2>
                <a className="popup-close" onClick={props.onClick}>&times;</a>
                <div className="popup-content">
                   {props.element}
                </div>
            </div>
        </div>
    );
}

export default PopUp;